import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AdminPageService {
    private apiBaseUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }

    getTruckCardDataList(searchQuery: any): Observable<{ ids: string[], totalCount: number }> {
        const endpoint = `${this.apiBaseUrl}InternalData/internal-truck-card-data-list`;
        return this.http.post<{ ids: string[], totalCount: number }>(endpoint, searchQuery);
    }
}
